const escapeCsvValue = (value) => {
  if (value === null || value === undefined) return '';
  const text = Array.isArray(value) ? value.join(', ') : String(value);
  return `"${text.replace(/"/g, '""')}"`;
};

export const exportToCsv = (filename, columns, rows) => {
  if (!rows?.length) return false;

  const csv = [
    columns.map(column => escapeCsvValue(column.label)).join(','),
    ...rows.map(row => columns.map(column => escapeCsvValue(
      typeof column.value === 'function' ? column.value(row) : row[column.value]
    )).join(','))
  ].join('\r\n');

  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return true;
};
